import { Device, until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import useMedia from '@hooks/useMedia';
import FeedCard from '@stories/Components/Cards/FeedCard/FeedCard';
import CarouselProvider from '@stories/Components/Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Misc/Carousels/Carousel/Pagination/Pagination';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './LatestFeed.styles';
const LatestFeed = ({ id, title, items }) => {
    const paddingOffset = useMedia([until(Device.TabletLarge)], [80], 0);
    if (!items || items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { id: id },
        title && React.createElement(S.Title, null, title),
        React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
            React.createElement(CarouselProvider, { count: items.length, paddingOffset: paddingOffset },
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { trackMutations: true }, items.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(FeedCard, { ...item })))))),
                React.createElement(Pagination, null)))));
};
export default withMotion(LatestFeed);
